import useSWR from 'swr';
import { useTranslation } from 'react-i18next';

import { getConfig } from 'configs';
import { LOCALES } from 'configs/getConfig';
import { fetcher } from 'utils';

interface Faq {
  faq: Array<{ question: string; answer: string }>;
}
export interface LifeFaq {
  lifeFaq: Array<{ question: string; answer: string; category: string; orderId: string }>;
}

type Language = 'zh' | 'en';

export const useFaq = () => {
  const { i18n } = useTranslation();
  const { cmsUrl } = getConfig();

  const locale = LOCALES.find((l) => l === i18n.language) ?? LOCALES[0];

  return useSWR<Faq>(cmsUrl.json.faq[locale], fetcher);
};

export const useLifeFaq = (language: Language) => {
  // const { i18n } = useTranslation();
  const { cmsUrl } = getConfig();
  // const locale = LOCALES.find((l) => l === i18n.language) ?? LOCALES[0];
  console.log('cmsUrl===================', cmsUrl);
  return useSWR<LifeFaq>(cmsUrl.json.lifeFaq[language], fetcher);
};
